if (!customElements.get('label-confirmation')) {
  customElements.define(
    'label-confirmation',
    class WhiteLabelBypass extends HTMLElement {

      constructor() {
        super();
        //console.log('label-confirmation mounted')
        this.mainBypassToggle = this.querySelector('#BypassInput');
        this.mainAcknowledgementToggle = this.querySelector('#AcknowledgementInput');
        this.mainReorderToggle = this.querySelector('#ReorderInput'); // New input
        this.requiredInputs = []; // Array to store required inputs
        this.bindEvents();
      }
    
      bindEvents() {
        this.mainBypassToggle?.addEventListener('click', this.onMainBypassToggle.bind(this));
        this.mainReorderToggle?.addEventListener('input', this.onMainReorderToggle.bind(this));
      }

      onMainBypassToggle() {
        //console.log('toggle Bypass')
        // Get input elements within the node
        const productLabel = document.querySelector('product-label');
        const inputElements = productLabel.querySelectorAll('input, textarea, select');

        if (this.mainBypassToggle.checked) {
          console.log('Bypass checked. Wipe and disable');

          // Clear value, disable, and remove required attribute
          this.mainAcknowledgementToggle.type === "checkbox" ? this.mainAcknowledgementToggle.checked = false : this.mainAcknowledgementToggle.value = "";
          this.mainAcknowledgementToggle.disabled = true;
          if(this.mainAcknowledgementToggle.require){
            this.requiredInputs.push(input); 
            input.removeAttribute('required');
            input.removeAttribute('aria-required');
          }

          // Clear all input values, disable input elements, and remove required attribute
          inputElements.forEach(input => {
            input.type === "checkbox" ? input.checked = false : input.value = "";
            input.disabled = true;
            if (input.required) {
              this.requiredInputs.push(input); // Store required inputs
              input.removeAttribute('required');
              input.removeAttribute('aria-required');
            }
          });
        } else {
          //console.log('Bypass unchecked. Re-Enable inputs');

          // Re-enable value, disable, and remove required attribute
          this.mainAcknowledgementToggle.disabled = false;
          if(this.requiredInputs.includes(this.mainAcknowledgementToggle)){
            this.mainAcknowledgementToggle.removeAttribute('required');
            this.mainAcknowledgementToggle.removeAttribute('aria-required');
            // Remove the input from the requiredInputs array
            this.requiredInputs.splice(this.requiredInputs.indexOf(this.mainAcknowledgementToggle), 1);
          }

          // Re-enable input elements and restore required attribute
          inputElements.forEach(input => {
            input.disabled = false;
            // Restore required attribute if it was required before
            if (this.requiredInputs.includes(input)) {
              input.setAttribute('required', true);
              input.setAttribute('aria-required', true);
              // Remove the input from the requiredInputs array
              this.requiredInputs.splice(this.requiredInputs.indexOf(input), 1);
            }
          });
        }
      }

      onMainReorderToggle() {
        //console.log('toggle Reorder')

        const productLabel = document.querySelector('product-label');
        const inputElements = productLabel.querySelectorAll('input, textarea, select');

        if (this.mainReorderToggle.value) {
          console.log('Reorder has value. Disabling other inputs');

          // Clear value, disable, and remove required attribute
          this.mainAcknowledgementToggle.type === "checkbox" ? this.mainAcknowledgementToggle.checked = false : this.mainAcknowledgementToggle.value = "";
          this.mainAcknowledgementToggle.disabled = true;
          if(this.mainAcknowledgementToggle.require){
            this.requiredInputs.push(input); 
            input.removeAttribute('required');
            input.removeAttribute('aria-required');
          }

          // Clear all input values, disable input elements, and remove required attribute
          inputElements.forEach(input => {
            input.type === "checkbox" ? input.checked = false : input.value = "";
            input.disabled = true;
            if (input.required) {
              this.requiredInputs.push(input); // Store required inputs
              input.removeAttribute('required');
              input.removeAttribute('aria-required');
            }
          });
        } else {
          //console.log('Reorder is empty. Enabling other inputs');

          // Re-enable value, disable, and remove required attribute
          this.mainAcknowledgementToggle.disabled = false;
          if(this.requiredInputs.includes(this.mainAcknowledgementToggle)){
            this.mainAcknowledgementToggle.removeAttribute('required');
            this.mainAcknowledgementToggle.removeAttribute('aria-required');
            // Remove the input from the requiredInputs array
            this.requiredInputs.splice(this.requiredInputs.indexOf(this.mainAcknowledgementToggle), 1);
          }

          // Re-enable input elements and restore required attribute
          inputElements.forEach(input => {
            input.disabled = false;
            // Restore required attribute if it was required before
            if (this.requiredInputs.includes(input)) {
              input.setAttribute('required', true);
              input.setAttribute('aria-required', true);
              // Remove the input from the requiredInputs array
              this.requiredInputs.splice(this.requiredInputs.indexOf(input), 1);
            }
          });
        }
      }
    }
  );
}
